import { createSlice } from '@reduxjs/toolkit';
import { apiUrl } from '../../utils/endPoints/apiUrl';
import { apiRequest } from '../../utils/config/apiRequest';

// Initial filter
const initialFilter = { page: 1, limit: 5, searchQ: '' };

// Initial state
const initialState = {
    isLoading: false,
    orderListing: { rows: [], count: 0, searchQ: '' },
    filter: initialFilter,
};

// Create the slice
const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        setOrdersLisitngs(state, action) {
            state.orderListing = action.payload;
        },

        setFilter(state, action) {
            state.filter = { ...initialFilter, ...action.payload };
        },
    },
});

// Export actions
export const { startLoading, stopLoading, setOrdersLisitngs, setFilter } = orderSlice.actions;

// Async Thunk to fetch the shop list
export const fetchOrderLisiting = async (dispatch) => {
    try {
        dispatch(startLoading());

        const { data, status } = await apiRequest({
            endUrl: apiUrl.orders.root,
            query: initialFilter,
        });

        if (status) {
            dispatch(setOrdersLisitngs({
                rows: data?.rows,
                count: data?.total,
            }));
        }
    } catch (error) {
        console.error('Error fetching Staff list:', error);
    } finally {
        dispatch(stopLoading());
    }
};

// Export the reducer
export default orderSlice.reducer;
